import React, { useState } from 'react';
import cx from 'classnames';
import { contacts } from 'constants/global';
import useResponsive from 'utils/hooks/useResponsive';
import MailIcon from 'assets/icons/mail.svg';
import PhoneIcon from 'assets/icons/phone-outlined.svg';
import ArrowIcon from 'assets/icons/arrow-left.svg';
import AltovitaIcon from 'assets/icons/altovita.ico';
import './Header.scss';


const Header = () => {
  const { isTablet, isMobile } = useResponsive();
  const [showContacts, setShowContacts] = useState(false);

  const linksClassNames = cx('header-contacts-links', {
    'header-contacts-links-shown': showContacts,
  });

  return (
    <div className="header-contacts">
      <div className="header-contacts-items">
        <button
          type="button"
          className="header-contacts-title"
          onClick={() => (isTablet || isMobile) && setShowContacts(!showContacts)}
        >
          {
            showContacts ? (
              (isTablet || isMobile) && <img alt="img" src={ArrowIcon} className="icon back" />
            ) : (
              <img alt="img" className="header-contacts-title-icon" src={AltovitaIcon} />
            )
          }
          {(isTablet || isMobile) && <img alt="img" src={PhoneIcon} className="icon icon-phone icon-mobile" />}
          <span>24/7 Customer & IT Support</span>
        </button>
        <div className={linksClassNames}>
          <a href="tel:+1 888-585-4609" className="header-contacts-link">
            <img alt="img" src={PhoneIcon} className="icon icon-phone" />
            US Toll Free
            {' '}
            <span>{contacts.US}</span>
          </a>
          <a href={`tel:${contacts.EMEA}`} className="header-contacts-link">
            <img alt="img" src={PhoneIcon} className="icon icon-phone" />
            EMEA (London)
            {' '}
            <span>{contacts.EMEA}</span>
          </a>
          <a href={`tel:${contacts.APAC}`} className="header-contacts-link">
            <img alt="img" src={PhoneIcon} className="icon icon-phone" />
            APAC (Singapore)
            {' '}
            <span>{contacts.APAC}</span>
          </a>
          <a href={`mailto: ${contacts.email}`} className="header-contacts-link">
            <img alt="img" src={MailIcon} className="icon icon-mail" />
            <span>{contacts.email}</span>
          </a>
        </div>
      </div>
    </div>

  );
};

export default Header;
